'use client';

import { useTranslations } from 'next-intl';
import Image from 'next/image';
import styles from './HowItWorks.module.css';

// Platform logos arranged in 3x3 grid - sized for 120px tall cells
const PLATFORM_LOGOS = [
  // Row 1
  { src: '/logos/Shopify_logo.svg', alt: 'Shopify', width: 160, height: 48 },
  { src: '/logos/WordPress_logo.svg', alt: 'WordPress', width: 200, height: 48 },
  { src: '/logos/Webflow_logo.svg', alt: 'Webflow', width: 144, height: 36 },
  // Row 2
  { src: '/logos/wix-logo.svg', alt: 'Wix', width: 80, height: 38 },
  { src: '/logos/ClickFunnels-Logo.svg', alt: 'ClickFunnels', width: 180, height: 36 },
  { src: '/logos/hubspot-logo.svg', alt: 'HubSpot', width: 160, height: 48 },
  // Row 3
  { src: '/logos/kajabi-logo.svg', alt: 'Kajabi', width: 160, height: 40 },
  { src: '/logos/magento-logo.svg', alt: 'Magento', width: 160, height: 48 },
  { src: '/logos/drupal-logo.svg', alt: 'Drupal', width: 160, height: 40 },
];

export function HowItWorks() {
  const t = useTranslations('audit.howItWorks');

  return (
    <section id="how-it-works" className={styles.section}>
      <div className="audit-container">
        <div className={styles.header}>
          <span className={styles.label}>{t('label')}</span>
          <h2 className={styles.title}>{t('title')}</h2>
        </div>

        <div className={styles.steps}>
          {/* Step 1 */}
          <div className={styles.step}>
            <span className={styles.stepNumber}>1</span>
            <div className={styles.stepContent}>
              <h3 className={styles.stepTitle}>{t('step1.title')}</h3>
              <p className={styles.stepDesc}>{t('step1.description')}</p>
            </div>
          </div>

          {/* Step 2 */}
          <div className={styles.step}>
            <span className={styles.stepNumber}>2</span>
            <div className={styles.stepContent}>
              <h3 className={styles.stepTitle}>{t('step2.title')}</h3>
              <p className={styles.stepDesc}>{t('step2.description')}</p>
            </div>
          </div>

          {/* Step 3 */}
          <div className={styles.step}>
            <span className={styles.stepNumber}>3</span>
            <div className={styles.stepContent}>
              <h3 className={styles.stepTitle}>{t('step3.title')}</h3>
              <p className={styles.stepDesc}>{t('step3.description')}</p>
            </div>
          </div>
        </div>

        {/* Platform Agnostic Section */}
        <div className={styles.platformSection}>
          <p className={styles.platformText}>{t('platforms.text')}</p>
          <div className={styles.platformLogos}>
            {PLATFORM_LOGOS.map((logo) => (
              <div key={logo.alt} className={styles.platformLogo}>
                <Image
                  src={logo.src}
                  alt={logo.alt}
                  width={logo.width}
                  height={logo.height}
                  style={{ objectFit: 'contain' }}
                />
              </div>
            ))}
          </div>
          <span className={styles.platformMore}>{t('platforms.more')}</span>
        </div>
      </div>
    </section>
  );
}
